<template>
    <div>
        <b-btn variant="warning" class="p-1 mr-1" @click="onEdit">
            <feather-icon icon="Edit3Icon"></feather-icon>
        </b-btn>
        <b-btn variant="danger" class="p-1 mr-1" @click="onDelete">
            <feather-icon icon="TrashIcon"></feather-icon>
        </b-btn>
        <structure-edit-modal ref="modal-edit" :structureData="structureData" :structures="structures" @on-refresh="$emit('on-refresh')"></structure-edit-modal>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import StructureEditModal from './Modals/edit.vue';
    export default {
        components: {
            StructureEditModal,
        },
        props: {
            structureData: {
                type: Object,
                required: true,
            },
            structures: {
                type: Array,
                required: true,
            },
        },
        computed: {
            ...mapGetters({
                modalContext: 'app/modalContext',
                successToast: 'app/successToast',
                errorToast: 'app/errorToast',
            }),
        },
        methods: {
            onEdit() {
                this.$refs['modal-edit'].open();
            },
            onDelete() {
                this.$bvModal
                    .msgBoxConfirm('Êtes-vous sûr de vouloir supprimer la structure ?', this.modalContext('danger'))
                    .then((confirmed) => {
                        if (confirmed) this.deleteStructure();
                    })
                    .catch((e) => {
                        console.error(e);
                    });
            },
            deleteStructure() {
                this.$root.toggleGlobalLoading(true);
                this.$store
                    .dispatch('app/deleteStructure', this.structureData.code)
                    .then((res) => {
                        this.$toast(this.successToast('La structure a été supprimée avec succès'));
                        this.$emit('on-refresh');
                    })
                    .catch((e) => {
                        this.$toast(this.successToast('Erreur lors de la suppresion de la structure'));
                        console.error(e);
                    })
                    .finally(() => {
                        this.$root.toggleGlobalLoading(false);
                    });
            },
        },
    };
</script>

<style></style>
